import {ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {Group} from "../../classes/Groups/Group";

@Component({
  selector: 'app-group-remove-confirmation-modal',
  templateUrl: './group-remove-confirmation-modal.component.html',
  styleUrls: ['./group-remove-confirmation-modal.component.scss']
})
export class GroupRemoveConfirmationModalComponent implements OnChanges{

  @Input() group:Group;
  @Output() onRemoveGroup = new EventEmitter<boolean>();

  Yiit = Yiit;
  constructor(private cd: ChangeDetectorRef) { }

  ngOnChanges(): void {
    console.log('ngOnchanges this.group', this.group);
    this.cd.detectChanges();
  }

  get isGroupFilled(){
    return this.group && this.group.getItems().length > 0;
  }

  get groupItemsCount(){
    return (this.group) ? this.group.getItems().length : 0;
  }

  confirmRemove(flag){
    this.onRemoveGroup.emit(flag);
  }

}
